import React from 'react';

interface IconProps {
    color: string;
    height?: any;
    width?: any;
}

const GreaterIcon: React.FC<IconProps> = ({color,height,width}) => {
    return (
        <svg 
            width={height ? `${height}px` : "8" }
            height={width ? `${width}px`: "10"}
            viewBox="0 0 8 12" 
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.600098 1.4L2.0001 0L8.0001 6L2.0001 12L0.600098 10.6L5.2001 6L0.600098 1.4Z" fill={color} />
        </svg>

    )
}

export default GreaterIcon;